import { localToday } from "../../../utils/dates";
import { AddCashbackFormValues } from "./types";

export const FORM_ID = "add-cashback";

export const ADD_CASHBACK_TITLE = "Add cashback";

export const ADD_CASHBACK_HELPER =
  "Cashback you received as cash. It's added to the account's balance as income.";

export const MISSING_CATEGORY_ERROR =
  "The Cashback category is missing, so cashback can't be added.";

export const createDefaultValues = (): AddCashbackFormValues => ({
  transactionDate: localToday(),
  amount: "",
  account: null,
  note: "",
});

const hasAmount = (value: unknown): value is number =>
  typeof value === "number" && !Number.isNaN(value);

export const AMOUNT_RULES = {
  validate: (value: unknown) => {
    if (!hasAmount(value)) {
      return "Amount is required";
    }
    return value > 0 ? true : "Amount must be greater than 0";
  },
};

export const DATE_RULES = { required: "Date is required" };

export const ACCOUNT_RULES = { required: "Account is required" };

export const NOTE_RULES = {
  minLength: { value: 3, message: "Description must be at least 3 characters" },
  maxLength: {
    value: 255,
    message: "Description cannot exceed 255 characters",
  },
};
